module.exports = __webpack_public_path__ + "media/images/lb/597-fd9b41d1821965353b706574b32a3603.svg";